import { Path } from './targets';

// Post-login `?next=<path>` whitelist. Only an internal `/mcp-authorize`
// path is honored; every other value — external, protocol-relative, or an
// unrelated internal path — is dropped, so a non-MCP login/SSO round-trip
// lands on the default destination rather than an arbitrary deep link. The
// OAuth consent handoff is the one flow that needs to return to where it
// started; nothing else does. This is the single gate every login-next
// consumer (sso-next-storage, login-next-storage, useLoginSubmit, the
// router guard) runs through, so the whitelist is enforced in one place.

export function isSafeNext(value: unknown): value is string {
  return typeof value === 'string' && value.startsWith(Path.McpAuthorize);
}
